import { getOnboardingIndex } from "../utils/localstorage";
import {
  INCREMENT_ONBOARDING,
  ASSIGNED_TOOLTIP_TO_MESSAGE,
} from "./onboarding-actions";

// Simplified onboarding - no message tooltips needed
const messageToolTipIndexes = new Set([]);

/*
Simplified Onboarding:
0. Type here to enter a message (input bar)
1. Click here for settings (settings button)
2. Switch between rooms (room switch button)
*/

export default (
  state = { 
    index: getOnboardingIndex(), 
    needsMessage: false,
    active: false // Controls whether onboarding tooltips should show
  },
  action
) => {
  switch (action.type) {
    case INCREMENT_ONBOARDING:
      return {
        ...state,
        index: state.index + 1,
        needsMessage: messageToolTipIndexes.has(state.index + 1)
      };
    case ASSIGNED_TOOLTIP_TO_MESSAGE:
      return {
        ...state,
        needsMessage: false
      };
    case 'RESET_ONBOARDING':
      return { 
        index: 0, 
        needsMessage: false,
        active: false 
      };
    case 'ACTIVATE_ONBOARDING':
      return {
        ...state,
        active: true
      };
    case 'DEACTIVATE_ONBOARDING':
      return {
        ...state,
        active: false
      };
    default:
      return state;
  }
};
